import React, { useEffect, useState } from 'react';
import axios from "axios";
import { useParams } from "react-router-dom";
import { useAuth } from '../../../../../context/AuthContext';
import 'quill/dist/quill.snow.css';
import { API_BASE_URL, EXPRESS_BASE_URL } from '../../../../../Helpers/apiConfig';

const AcceptanceModal = ({ title, html, onClose, onAccept }) => (
    <div className="modal d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
        <div className="modal-dialog modal-dialog-scrollable modal-lg">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">{title}</h5>
                    <button type="button" className="btn-close" aria-label="Kapat" onClick={onClose}></button>
                </div>
                <div className="modal-body text-start">
                    {html ? (
                        <div className="ql-editor" style={{ padding: 0 }} dangerouslySetInnerHTML={{ __html: html }} />
                    ) : (
                        <p>Yükleniyor...</p>
                    )}
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-primary" onClick={onAccept}>Kabul Ediyorum</button>
                </div>
            </div>
        </div>
    </div>
);

export const Odemetest = () => {
    const { packageId, price } = useParams();
    const { user } = useAuth();
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState("");
    const [phone, setPhone] = useState("");

    const [mainTexts, setMainTexts] = useState({ onbilgilendirme: "", satissozlesmesi: "" });
    const [showPreInfoModal, setShowPreInfoModal] = useState(false);
    const [showDistanceSalesModal, setShowDistanceSalesModal] = useState(false);
    const [acceptedPreInfo, setAcceptedPreInfo] = useState(false);
    const [acceptedDistanceSales, setAcceptedDistanceSales] = useState(false);
    const [acceptedDigitalContent, setAcceptedDigitalContent] = useState(false);

    const allAccepted = acceptedPreInfo && acceptedDistanceSales && acceptedDigitalContent;

    useEffect(() => {
        const fetchMainTexts = async () => {
            try {
                const res = await axios.get(`${EXPRESS_BASE_URL}/getmaintexts`);
                const row = (res.data && res.data[0]) || {};
                setMainTexts({
                    onbilgilendirme: row.onbilgilendirme || "",
                    satissozlesmesi: row.satissozlesmesi || "",
                });
            } catch (err) {
                console.error("Sözleşme metinleri alınamadı:", err);
            }
        };
        fetchMainTexts();
    }, []);

    const getPaymentToken = async (userPhone) => {
        setLoading(true);
        setMsg("");
        try {
            const headerss = {
                "accept": "*/*",
                "Content-Type": "application/json",
                "Authorization": "Bearer " + user.token
            };

            const res = await axios.post(
                API_BASE_URL + "/Paytr/GetToken",
                {
                    packageId: packageId,
                    userPhone: userPhone,
                },
                { headers: headerss }
            );

            if (res.data && res.data.success && res.data.token) {
                setToken("https://www.paytr.com/odeme/guvenli/" + res.data.token);
            } else {
                setMsg(res.data?.message || "Ödeme sayfası oluşturulamadı.");
            }
        } catch (err) {
            setMsg(err.response?.data?.message || "Ödeme sayfası oluşturulurken beklenmedik bir hata oluştu.");
        }
        setLoading(false);
    };

    const recordPurchaseAcceptance = async () => {
        try {
            await axios.post(`${EXPRESS_BASE_URL}/postindividualpurchaseaccepted`, {
                userid: user.user.id,
                name: user.user.fullName,
                email: user.user.username,
                onbilgilendirme: 1,
                satissozlesmesi: 1,
                caymahakki: 1,
            });
        } catch (err) {
            console.error("Satın alma kabul kaydı oluşturulamadı:", err);
        }
    };

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://www.paytr.com/js/iframeResizer.min.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);

    const handlePhoneSubmit = (e) => {
        e.preventDefault();
        if (!allAccepted) return;
        recordPurchaseAcceptance();
        getPaymentToken(phone);
    };

    return (
        <div className="container text-center my-4">
            <h4>Ödeme — {price} TL</h4>
            <hr />

            {!loading && !token && (
                <form onSubmit={handlePhoneSubmit} className="mx-auto" style={{ maxWidth: "500px" }}>
                    <p className="text-muted">Ödemeye devam etmek için telefon numaranızı girin.</p>
                    <div className="mb-3">
                        <input
                            type="tel"
                            className="form-control"
                            placeholder="05XX XXX XX XX"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            required
                        />
                    </div>

                    <div className="text-start mb-3">
                        <div className="form-check mb-2">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="acceptPreInfo"
                                checked={acceptedPreInfo}
                                onChange={(e) => setAcceptedPreInfo(e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="acceptPreInfo">
                                <span
                                    style={{ color: "#0d6efd", textDecoration: "underline", cursor: "pointer" }}
                                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); setShowPreInfoModal(true); }}
                                >Ön Bilgilendirme Formunu</span>&nbsp;Okudum kabul ediyorum.
                            </label>
                        </div>
                        <div className="form-check mb-2">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="acceptDistanceSales"
                                checked={acceptedDistanceSales}
                                onChange={(e) => setAcceptedDistanceSales(e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="acceptDistanceSales">
                                <span
                                    style={{ color: "#0d6efd", textDecoration: "underline", cursor: "pointer" }}
                                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); setShowDistanceSalesModal(true); }}
                                >Mesafeli Satış Sözleşmesini</span>&nbsp;Okudum Kabul Ediyorum.
                            </label>
                        </div>
                        <div className="form-check mb-2">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="acceptDigitalContent"
                                checked={acceptedDigitalContent}
                                onChange={(e) => setAcceptedDigitalContent(e.target.checked)}
                            />
                            <label
                                className="form-check-label"
                                htmlFor="acceptDigitalContent"
                                style={{ color: "#0d6efd", textDecoration: "underline" }}
                            >
                                Dijital içeriğin hemen sunulmaya başlamasını onaylıyorum ve cayma hakkımın sona ereceğini kabul ediyorum.
                            </label>
                        </div>
                    </div>

                    {msg && <div className="alert alert-danger">{msg}</div>}
                    <button type="submit" className="btn btn-primary" disabled={!allAccepted}>Devam Et</button>
                </form>
            )}

            {loading && (
                <div className="my-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Yükleniyor...</span>
                    </div>
                    <p className="mt-2 text-muted">Ödeme sayfası hazırlanıyor...</p>
                </div>
            )}

            {!loading && token && (
                <iframe
                    src={token}
                    id="paytriframe"
                    frameBorder="0"
                    style={{ width: "100%", height: "1000px" }}
                    title="Ödeme"
                ></iframe>
            )}

            {showPreInfoModal && (
                <AcceptanceModal
                    title="Ön Bilgilendirme Formu"
                    html={mainTexts.onbilgilendirme}
                    onClose={() => setShowPreInfoModal(false)}
                    onAccept={() => { setAcceptedPreInfo(true); setShowPreInfoModal(false); }}
                />
            )}

            {showDistanceSalesModal && (
                <AcceptanceModal
                    title="Mesafeli Satış Sözleşmesi"
                    html={mainTexts.satissozlesmesi}
                    onClose={() => setShowDistanceSalesModal(false)}
                    onAccept={() => { setAcceptedDistanceSales(true); setShowDistanceSalesModal(false); }}
                />
            )}
        </div>
    );
};

export default Odemetest;
